/* @flow */

export {colors} from './colors';
export type {ColorName} from './colors';
